import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './tabs-with-image.module.scss';
import {
  DynamicMediaPicture,
  SingleDynamicMediaImageConfigs,
  DynamicMediaPictureProps
} from '../dynamic-media-picture';

export type TabsWithImageProps = {
  className?: string;
  initialTab?: number;
  items: {
    image: Omit<DynamicMediaPictureProps, 'imageConfigs' | 'isObjectFit' | 'hasDarkeningLayer' | 'className'>;
    headline: string;
    content: JSX.Element;
    id: string;
    disabled?: boolean;
    onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  }[];
};

const imageConfig: SingleDynamicMediaImageConfigs = [
  {
    aspectRatio: '4-3',
    sizes: '5vw'
  }
];

export const TabsWithImage: React.FC<TabsWithImageProps> = ({ items, className, initialTab }) => {
  const [isActive, setIsActive] = useState(initialTab || 0);

  return (
    <div className={classnames(styles.tabs, className)} data-testid="tabswithimage-component">
      <div role="tablist" className={styles.tablist}>
        {items.map((item, i) => {
          const buttonClass = classnames(styles.button, {
            [styles.active]: i === isActive
          });

          return (
            <button
              key={`${item.headline}-${i}-control`}
              id={`${item.id}-control`}
              aria-controls={`${item.id}-panel`}
              aria-selected={i === isActive}
              className={buttonClass}
              role="tab"
              onClick={(e) => {
                setIsActive(i);
                item.onClick && item.onClick(e);
              }}
              disabled={item.disabled}
            >
              <DynamicMediaPicture
                {...item.image}
                imageConfigs={imageConfig}
                className={styles.image}
                hasImageTransparency
                noLoadingLogo
                omitAspectRatioInUrl
              />
              <div>{item.headline}</div>
            </button>
          );
        })}
      </div>
      {items.map((item, i) => {
        const panelClass = classnames(styles.panel, {
          [styles.active]: i === isActive
        });

        return (
          <div
            aria-hidden={i !== isActive}
            key={`${item.headline}-${i}-panel`}
            id={`${item.id}-panel`}
            role="tabpanel"
            aria-labelledby={`${item.id}-control`}
            className={panelClass}
          >
            {item.content}
          </div>
        );
      })}
    </div>
  );
};
